import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class ServiceAdditionalProposalService {
  private baseUrl = environment.baseUrl
  private resource: string = 'PropostaServicoAdicional'

  constructor(private httpClient: HttpClient) {}

  public createServiceAdditionalProposal(
    model: any,
    // model: CreateServiceAdditionalModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editServiceAdditionalProposal(
    model: any,
    // model: EditServiceAdditionalModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public duplicateServiceAdditionalProposal(
    proposalId: number,
    itemadicionalId: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/ReplicarServico/PropostaId/${proposalId}/${itemadicionalId}`,
      {},
    )
  }

  public removeServiceAdditionalProposal(
    idServiceAditional: number,
    // model: DeleteServiceAdditionalModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/remove/${idServiceAditional}`,
      {},
    )
  }

  public listPagedServiceAdditionalByProposalId(
    page: number,
    rows: number = 15,
    idProposal: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Proposta/listpaginated/${idProposal}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listServiceAdditionalByProposalId(
    idProposal: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Proposta/${idProposal}`,
    )
  }

  public getServiceAdditionalById(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedServiceAdditionalProposal(
    page: number,
    rows: number = 15,
    model: any,
    // model: SearchServiceAdditionalModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public searchServiceAdditionalProposal(
    string: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      {
        descricao: string,
      },
    )
  }

  public getServiceAdditionalValueByProposalId(
    proposalId: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/ValorTotal/PropostaId/${proposalId}`,
    )
  }

  public searchServiceAdditionalProposalByDate(
    string: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/searchbyeventdate`,
      {
        diaEvento: string,
      },
    )
  }
}
